import { createHOC } from 'vue-hoc';
import isEqual from 'lodash/isEqual';
import Promise from 'bluebird';
import withUser from '~lib/common/hoc/withUser';

import auth from '~lib/common/providers/auth';
import userManagement from '~lib/common/providers/userManagement';

import CaseDiffTool from './CaseDiffTool';
import removeUncomparableCaseFields from './removeUncomparableCaseFields';

const options = {
  name: 'CaseDiffToolContainer',
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      state: {
        loading: false,
        diffing: false,
        fromEnv: 'dev',
        toEnv: 'dev',
        error: null,
      },
    };
  },
  async created() {
    if (!(await auth.isAuthenticated())) {
      this.$router.replace({ name: 'login' });
      return;
    }
  },
  methods: {},
};

const renderWith = {
  props: {
    loading() {
      return this.state.loading;
    },
    diffing() {
      return this.state.diffing;
    },
    error() {
      return this.state.error;
    },
  },
  listeners: {
    updateFromEnv(env) {
      this.state.fromEnv = env;
    },
    updateToEnv(env) {
      this.state.toEnv = env;
    },
    async diff(fromCaseId, toCaseId, fromOrg, toOrg, fromUser, toUser) {
      console.log(fromCaseId, toCaseId, fromOrg, toOrg, fromUser, toUser);
      try {
        this.state.diffing = true;
        this.state.error = null;
        const { fromEnv, toEnv } = this.state;

        const [
          fromUserLoginAsResponse,
          toUserLoginAsResponse,
        ] = await Promise.all([
          userManagement.post('/auth/loginAs', {
            orgId: fromOrg._id,
            email: fromUser.email,
          }),
          userManagement.post('/auth/loginAs', {
            orgId: toOrg._id,
            email: toUser.email,
          }),
        ]);

        const fromUserToken = fromUserLoginAsResponse.data.idToken;
        const toUserToken = toUserLoginAsResponse.data.idToken;

        const [fromCaseJson, toCaseJson] = await Promise.all([
          fetch(
            `https://${fromEnv}.vrpatients.com/api/cases/${fromCaseId}?code=obuicX9hPVJ1NlQyepu9lg==`,
            {
              headers: {
                Authorization: `Bearer ${fromUserToken}`,
              },
            }
          ).then(async (response) => {
            if (response.ok) {
              return response.json();
            }
            const data = await response.json();
            throw new Error(
              `Error when fetching case in source environment: ${(data &&
                data.errorInfo &&
                data.errorInfo.error) ||
                'unknown error'}`
            );
          }),
          fetch(
            `https://${toEnv}.vrpatients.com/api/cases/${toCaseId}?code=obuicX9hPVJ1NlQyepu9lg==`,
            {
              headers: {
                Authorization: `Bearer ${toUserToken}`,
              },
            }
          ).then(async (response) => {
            if (response.ok) {
              return response.json();
            }
            const data = await response.json();
            throw new Error(
              `Error when fetching case in target environment: ${(data &&
                data.errorInfo &&
                data.errorInfo.error) ||
                'unknown error'}`
            );
          }),
        ]);

        const comparableFromCaseJson = removeUncomparableCaseFields(fromCaseJson);
        const comparableToCaseJson = removeUncomparableCaseFields(toCaseJson);
        if (!isEqual(comparableFromCaseJson, comparableToCaseJson)) {
          const error = new Error(
            'Case data is different'
          );
          error.code = 'CASE_JSON_NOT_EQUAL';
          error.fromCaseJson = JSON.stringify(
            comparableFromCaseJson,
            null,
            2
          );
          error.toCaseJson = JSON.stringify(
            comparableToCaseJson,
            null,
            2
          );
          throw error;
        }
      } catch (e) {
        console.error(e);
        if (e.graphqlErrors && e.graphqlErrors.length) {
          this.state.error = e.graphqlErrors[0];
        }
        this.state.error = e;
      } finally {
        this.state.diffing = false;
      }
    },
  },
};

const CaseDiffToolContainer = createHOC(CaseDiffTool, options, renderWith);
export default withUser()(CaseDiffToolContainer);
